import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { AddToCartMutationVariables, SCartDto } from "@/__generated__/sdk";
import { Session } from "next-auth";

export interface SessionState {
  session: Session | null;
  status: "unauthenticated" | "loading" | "authenticated";
}

const initialState = { session: null, status: "unauthenticated" } satisfies SessionState as SessionState;

const sessionSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    setSession(state, action: PayloadAction<SessionState>) {
      state.session = action.payload?.session;
      state.status = action.payload?.status;
    },
  },
});

export const { setSession } = sessionSlice.actions;
export default sessionSlice.reducer;
